export const calculateCountdown = (endDate: string | undefined, startDate?: string | undefined) => {
  const now = new Date().getTime()

  if (startDate !== undefined) {
    const utcStart = new Date(startDate || '')
    const start = new Date(
      utcStart.getUTCFullYear(),
      utcStart.getUTCMonth(),
      utcStart.getUTCDate(),
      utcStart.getUTCHours(),
      utcStart.getUTCMinutes(),
      utcStart.getUTCSeconds(),
    ).getTime()

    const timeToStart = start - now

    const hours = Math.floor(timeToStart / (1000 * 60 * 60))
    const minutes = Math.floor((timeToStart % (1000 * 60 * 60)) / (1000 * 60))
    const seconds = Math.floor((timeToStart % (1000 * 60)) / 1000)

    if (timeToStart >= 0) {
      return {
        message: 'Start is expected',
        time: `${String(hours).padStart(2, '0')}:${String(minutes).padStart(2, '0')}:${String(seconds).padStart(2, '0')}`,
      }
    }
  }

  const utcEnd = new Date(endDate || '')
  const end = new Date(
    utcEnd.getUTCFullYear(),
    utcEnd.getUTCMonth(),
    utcEnd.getUTCDate(),
    utcEnd.getUTCHours(),
    utcEnd.getUTCMinutes(),
    utcEnd.getUTCSeconds(),
  ).getTime()

  const differenceInMc = end - now

  if (differenceInMc <= 0) {
    return { time: '00:00:00' }
  }

  const hours = Math.floor(differenceInMc / (1000 * 60 * 60))
  const minutes = Math.floor((differenceInMc % (1000 * 60 * 60)) / (1000 * 60))
  const seconds = Math.floor((differenceInMc % (1000 * 60)) / 1000)

  return {
    message: 'Активна',
    time: `${String(hours).padStart(2, '0')}:${String(minutes).padStart(2, '0')}:${String(seconds).padStart(2, '0')}`,
  }
}
